import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import { setIsMarketDataLoaded } from 'redux/modules/marketGraph';

import styles from './MarketGraphClosePageBtn.module.scss';

type MarketGraphClosePageBtnProps = {
  iconClassName?: string;
};

export default function MarketGraphClosePageBtn({ iconClassName = '' }: MarketGraphClosePageBtnProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <button
      className={styles.closeBtn}
      onClick={() => {
        dispatch(setIsMarketDataLoaded(false));
        navigate(-1);
      }}
    >
      <i className={classNames('fa2 fa2-cross-24', styles.closeBtn__icon, iconClassName)} />
    </button>
  );
}
